// PRD 07 §4.1 — Status / Save Date cell.
//   PUBLISHED → green "Saved" badge with the YYYY.MM.DD date below.
//   DRAFT     → neutral "Draft" badge, no date.

import { useTranslation } from 'react-i18next';

import type { ManagementGuideline } from '../types/management-guidelines.types';

interface GuidelineStatusBadgeProps {
  guideline: Pick<ManagementGuideline, 'status' | 'deployedAt'>;
}

export function GuidelineStatusBadge({ guideline }: GuidelineStatusBadgeProps) {
  const { t } = useTranslation('management-guidelines');

  if (guideline.status === 'PUBLISHED') {
    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
        <span className="badge badge-success">
          {t('statuses.published')}
        </span>
        {guideline.deployedAt ? (
          <span style={{ fontSize: 11, color: 'var(--muted-foreground)' }}>
            {guideline.deployedAt}
          </span>
        ) : null}
      </div>
    );
  }

  return (
    <span className="badge" style={{ background: 'var(--muted)', color: 'var(--muted-foreground)' }}>
      {t('statuses.draft')}
    </span>
  );
}
